import { render, staticRenderFns } from "./ConfigTabRequestTypes.vue?vue&type=template&id=048e0380"
import script from "./ConfigTabRequestTypes.vue?vue&type=script&lang=js"
export * from "./ConfigTabRequestTypes.vue?vue&type=script&lang=js"
import style0 from "./ConfigTabRequestTypes.vue?vue&type=style&index=0&id=048e0380&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports